import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required("forgetpassword.required")
    .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{12,}$/,
      "forgetpassword.password_complexity"
    ),
  password_repeat: Yup.string()
    .oneOf([Yup.ref("password"), null], "forgetpassword.passwords_not_match")
    .required("forgetpassword.required"),
});
